import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHomeRoundDoor: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconHomeRoundDoor"><Path d="M9.5 17V20.5H3.5V8.8125L12 3.5L20.5 8.8125V20.5H14.5V17C14.5 15.6193 13.3807 14.5 12 14.5C10.6193 14.5 9.5 15.6193 9.5 17Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconHomeRoundDoor;
